module.exports = __webpack_public_path__ + "img/dusted_fingerprint.7515f601.jpg";